// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"26530191","498":"3f02b585","513":"0dd0475e","703":"13b37a9b"}[chunkId] + ".chunk.js";
};